module.exports = __webpack_public_path__ + "static/media/BrightPoint_4C.704c037a.svg";